import { memo, useEffect, useRef } from "react";
import { Chart, registerables } from "chart.js";
import { useAppDispatch, useAppSelector } from "../../../../../redux/hooks";
import { ConditionName } from "../../../../../interfaces";
import { conditions, responseValidator, videoTag } from "../../../../../helpers";
import { API, apiCaller } from "../../../../../services";
import { setChartPoints } from "../../../../../redux/slices/videoDataSlice";
import { shallowEqual } from "react-redux";
Chart.register(...registerables);

const ViewersChart = () => {
    const dispatch = useAppDispatch();
    const { chartPoints } = useAppSelector(({ videoData: { chartPoints, isComplexPortrait } }) => ({ chartPoints, isComplexPortrait }), shallowEqual);
    const chartRef = useRef<any>(null);

    useEffect(() => {
        if (conditions(ConditionName.hasChart)) {
            if (conditions(ConditionName.isLiveParam)) handleChart(chartPoints);
            else {
                (async () => {
                    const { data, status } = await apiCaller({ url: API().getViewersWindow });
                    if (responseValidator(status)) {
                        if (data.windows.length) {
                            const points: number[] = [];
                            data.windows.map((window: { window_number: number; viewers: number }) => points.push(window.viewers));
                            dispatch(setChartPoints(points));
                        }
                    }
                })();
            }
        }
    }, []);

    const handleChart = (points: number[]) => {
        if (conditions(ConditionName.hasChartPoints)) {
            const viewersChart: any = document.getElementById("viewersChart")!;
            var ctx: any = viewersChart.getContext("2d");
            chartRef.current = new Chart(ctx, {
                type: "line",
                data: {
                    labels: points,
                    datasets: [
                        {
                            data: points,
                            backgroundColor: "rgba(247, 248, 253, 0.3)",
                            fill: true,
                            tension: 0.5
                        }
                    ]
                },
                options: {
                    plugins: {
                        tooltip: { enabled: false },
                        legend: { display: false }
                    },
                    scales: {
                        x: {
                            display: false,
                            ticks: {
                                stepSize: points.length >= 1000 ? videoTag().duration / 1000 : 2
                            }
                        },
                        y: {
                            display: false
                        }
                    },
                    elements: {
                        point: {
                            radius: 0
                        },
                        line: {
                            borderColor: "transparent"
                        }
                    },
                    animation: {
                        duration: conditions(ConditionName.isLiveParam) ? 0 : 500
                    }
                }
            });
        }
    };

    useEffect(() => {
        if (!conditions(ConditionName.isLiveParam)) handleChart(chartPoints);
    }, [chartPoints.length]);

    useEffect(() => {
        if (conditions(ConditionName.hasChartPoints) && conditions(ConditionName.isLiveParam) && !!chartRef.current) {
            chartRef.current.data.datasets[0].data = chartPoints;
            chartRef.current.update();
        }
    });

    return (
        <>
            {!!conditions(ConditionName.hasChartPoints) && (
                <div className={`pl-w-full pl-h-[48px]`}>
                    <div className="pl-w-full pl-h-full pl-flex pl-mx-auto pl-my-auto">
                        <div className="pl-pt-0 pl-w-full pl-h-full pl-my-auto pl-shadow-xl">
                            <canvas
                                className="!pl-w-full !pl-h-full"
                                id="viewersChart"
                                style={{ height: 400, position: "absolute", bottom: conditions(ConditionName.isTouchScreen) ? "3.6px" : "3px" }}
                            ></canvas>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default memo(ViewersChart);
